import { useContext, useEffect, useRef, useState } from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import { BsArrowsFullscreen } from 'react-icons/bs';
import { useSnackbar } from 'notistack';
import ChatWindow from './ChatWindow';
import CopilotModal from './CopilotModal';
import { data } from './mock data/dummyChat';
import ChatInputField from './copilot-component/ChatInputField';
import { WorkflowContext } from '../../../contexts/WorkflowProvider';
import { ETL_COPILOT } from './copilot-constant/Images';
import { ETL_COPILOT_WEB_SOCKET_URL } from '../../../BaseUrl';
import { AddXLevels } from './utils/AddXLevel';

// const data = [];

function Copilot({ socket, chatHistory, setChatHistory, etlCopilotSocketConnected }) {
  const { workflow, setWorkflow } = useContext(WorkflowContext);
  const [userMessage, setUserMessage] = useState('');
  const chatHistoryEndRef = useRef(null);
  const chatContainerRef = useRef(null);
  const [shouldAutoScroll, setShouldAutoScroll] = useState(true);
  const [openModal, setOpenModal] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    const el = chatContainerRef.current;
    if (!el) return;

    const handleScroll = () => {
      const isAtBottom = el.scrollHeight - el.scrollTop <= el.clientHeight + 10;
      setShouldAutoScroll(isAtBottom);
    };

    el.addEventListener('scroll', handleScroll);
    return () => el.removeEventListener('scroll', handleScroll);
  }, []);

  // useEffect(() => {
  //   setChatHistory(data);
  // }, [data]);

  // console.log('chatHistory: ', chatHistory);
  const handleInputChange = (e) => {
    setUserMessage(e.target.value);
  };

  useEffect(() => {
    if (chatHistoryEndRef.current && shouldAutoScroll) {
      chatHistoryEndRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [chatHistory, shouldAutoScroll]);

  const sendUserMessage = (defaultMessage = '') => {
    if (socket?.readyState === WebSocket.OPEN && (userMessage.trim() || defaultMessage)) {
      const userPrompt = defaultMessage || userMessage;
      socket.send(userPrompt);
      setUserMessage('');
      setChatHistory((prev) => [...prev, { content: userPrompt, type: 'text', sender: 'user', timestamp: Date.now() }]);
    } else {
      enqueueSnackbar(`ETL Copilot connection lost. Message not sent!`, {
        variant: 'error',
        autoHideDuration: 3500,
        anchorOrigin: { vertical: 'top', horizontal: 'right' },
      });
    }
  };

  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false);

  const handleAddNode = (block) => {
    const previousCopilotAddedNodes = workflow.copilotAddedNodes || [];
    setWorkflow({
      ...workflow,
      copilotAddedNodes: [...previousCopilotAddedNodes, { block, status: 'pending', id: `${Date.now()}` }],
    });
  };

  const handleAddPipeline = (pipeline) => {
    const previousCopilotAddedPipeline = workflow.copilotAddedPipeline || [];
    setWorkflow({
      ...workflow,
      copilotAddedPipeline: [...previousCopilotAddedPipeline, { pipeline, status: 'pending', id: `${Date.now()}` }],
    });
    if (openModal) {
      enqueueSnackbar(`Pipeline added to Workflow!`, {
        variant: 'success',
        autoHideDuration: 3000,
        anchorOrigin: { vertical: 'top', horizontal: 'center' },
      });
    }
  };

  return (
    <>
      <Box
        sx={{
          border: '1px solid lightgray',
          borderRadius: '3px',
          backgroundColor: '#fff',
          height: '100%',
          padding: 2,
          marginLeft: '8px',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        {/* Header with icon */}
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between', // Space between title and full view
            mb: 2,
            pb: 2,
            borderBottom: '1px solid lightgray',
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <img src={ETL_COPILOT.LOGO} alt="Copilot" style={{ height: 24, marginRight: 8 }} />
            <Typography variant="h6" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              ETL Copilot
              <Box
                sx={{
                  width: 10,
                  height: 10,
                  borderRadius: '50%',
                  backgroundColor: etlCopilotSocketConnected ? '#4CAF50' : '#f44336', // green or red
                }}
              />
            </Typography>
          </Box>
          <IconButton onClick={handleOpenModal} sx={{ color: 'inherit' }}>
            {/* <FullscreenIcon /> */}
            <BsArrowsFullscreen size={20} />
          </IconButton>
        </Box>

        {/* Scrollable content area (even if empty for now) */}
        <Box
          ref={chatContainerRef}
          sx={{
            flex: 1,
            minHeight: 0,
            overflowY: 'auto',
            pb: 2,
          }}
        >
          {/* You can put messages/chat here later */}
          <ChatWindow
            data={chatHistory}
            handleAddNode={handleAddNode}
            handleAddPipeline={handleAddPipeline}
            chatHistoryEndRef={chatHistoryEndRef}
            setUserMessage={setUserMessage}
            sendUserMessage={sendUserMessage}
          />
        </Box>

        {/* Input field */}
        <ChatInputField
          userMessage={userMessage}
          handleInputChange={handleInputChange}
          sendUserMessage={sendUserMessage}
          // disabled={!socket || socket.readyState !== WebSocket.OPEN}
        />
      </Box>
      <CopilotModal
        open={openModal}
        onClose={handleCloseModal}
        data={chatHistory}
        userMessage={userMessage}
        handleInputChange={handleInputChange}
        setUserMessage={setUserMessage}
        sendUserMessage={sendUserMessage}
        handleAddNode={handleAddNode}
        handleAddPipeline={handleAddPipeline}
        etlCopilotSocketConnected={etlCopilotSocketConnected}
        chatHistoryEndRef={chatHistoryEndRef}
        // disabled={!socket || socket.readyState !== WebSocket.OPEN}
      />
    </>
  );
}

export default Copilot;
